import { Tooltip } from "react-tooltip";
import FadeIn from "@/app/components/ui/FadeIn";
import { IBookingFiltersProps } from "@/app/components/routes/auth_routes/SlotsScreen/interface";
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import QuickDateFilters from "@/app/components/ui/QuickDateFilters";
import { BsCurrencyRupee, BsExclamationCircle } from "react-icons/bs";
import NudgesContainer from "@/app/components/ui/Nudges/NudgesContainer";
import QuickServiceFilters from "@/app/components/ui/QuickServiceFilters";
import SendVCLink from "@/app/components/routes/auth_routes/SlotsScreen/SendVCLink";
import { alert_category_list } from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/constants";
import { useBookingFilters } from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/useBookingFilters";
import BookingFiltersHeader from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/components/BookingFiltersHeader";
import BookingFilterFields from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/components/BookingFilterFields";
import HomeServiceAddress from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/components/HomeServiceAddress";
import NearbyLocationSearch from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/components/NearbyLocationSearch";

const BookingFiltersComponent: React.FC<IBookingFiltersProps> = (_props) => {
  const {
    formHook,
    page,
    customer,
    lastBookingChip,
    checkPrice,
    filterFields,
    homeAddress,
    nearbyLocation,
    vcLink,
    banners,
    isFrontDeskOverbooking,
    handelSelectClinic,
    onSubmit,
    setSelectedDate,
    setSelecteSubService,
  } = useBookingFilters();

  const { isPageReadonly, disableSlotsFilter, showFilters, isHomeServiceFlow, isReadonlyHomeServiceFlow, isAtHomeReschedule } =
    page;
  const { customerId, petId, petDetails } = customer;
  const {
    shouldShowLatestBookingChip,
    latestBooking,
    isLatestBookingInProgress,
    latestBookingTitle,
    latestBookingClinicAndCity,
    applyLastBookingFilters,
  } = lastBookingChip;
  const { isCheckPricesOpen, setIsCheckPricesOpen, handleCheckPriceClick } = checkPrice;
  const {
    petSpeciesItems,
    serviceTypeItems,
    l2ServiceItems,
    cityItems,
    clinicItems,
    providerItems,
    setSelectedClinic,
  } = filterFields;
  const {
    selectedAddressText,
    isAddressListModalOpen,
    setIsAddressListModalOpen,
    isAddAddressModalOpen,
    setIsAddAddressModalOpen,
    selectedAddressId,
    setSelectedAddressId,
    slotsAddressList,
    setSlotsAddressList,
    handleAddressSelectionForHomeService,
  } = homeAddress;
  const { handleNearbyLocationSelect, handleNearbyLocationClear } = nearbyLocation;
  const { showBDTemplateButton, openVCLink, setOpenVCLink, handleBDTemplateClick, rescheduleBookingId } = vcLink;
  const {
    isPaidbooking,
    isPaidPriceAmount,
    isSearchSlotButtonClick,
    hasShownNudges,
    filtersError,
    subServiceToServiceIdMap,
  } = banners;
  const { selectedQuickServiceIds } = filterFields;

  return (
    <div>
      <BookingFiltersHeader
        isPageReadonly={isPageReadonly}
        shouldShowLatestBookingChip={shouldShowLatestBookingChip}
        applyLastBookingFilters={applyLastBookingFilters}
        disableSlotsFilter={disableSlotsFilter}
        isAtHomeReschedule={isAtHomeReschedule}
        isLatestBookingInProgress={isLatestBookingInProgress}
        latestBooking={latestBooking}
        latestBookingTitle={latestBookingTitle}
        latestBookingClinicAndCity={latestBookingClinicAndCity}
        handleCheckPriceClick={handleCheckPriceClick}
        handelSelectClinic={handelSelectClinic}
        isCheckPricesOpen={isCheckPricesOpen}
        setIsCheckPricesOpen={setIsCheckPricesOpen}
      />
      <div className="bg-white p-3 w-full">
        <div className="flex items-center justify-between w-auto">
          <QuickDateFilters setSelectedDate={setSelectedDate} selectedDate={formHook.watch("date")} />
          <QuickServiceFilters
            selectedSubService={formHook.watch("subService")}
            selectedServiceIds={selectedQuickServiceIds}
            setSelecteSubService={setSelecteSubService}
            disabled={disableSlotsFilter || isAtHomeReschedule}
            excludeAHS={isFrontDeskOverbooking}
          />
        </div>
        <FadeIn show={showFilters}>
          <form className={`${isPageReadonly ? "mt-3" : "mt-4"} w-full `} onSubmit={formHook.handleSubmit(onSubmit)}>
            <div className="flex justify-start items-center w-full">
              <BookingFilterFields
                formHook={formHook}
                isPageReadonly={isPageReadonly}
                disableSlotsFilter={disableSlotsFilter}
                petSpeciesItems={petSpeciesItems}
                serviceTypeItems={serviceTypeItems}
                l2ServiceItems={l2ServiceItems}
                isHomeServiceFlow={isHomeServiceFlow}
                isAtHomeReschedule={isAtHomeReschedule}
                cityItems={cityItems}
                clinicItems={clinicItems}
                providerItems={providerItems}
                hideProviders={isFrontDeskOverbooking}
                setSelectedClinic={setSelectedClinic}
              />
              <HomeServiceAddress
                isHomeServiceFlow={isHomeServiceFlow}
                isReadonlyHomeServiceFlow={isReadonlyHomeServiceFlow}
                selectedAddressText={selectedAddressText}
                disableSlotsFilter={disableSlotsFilter}
                isAddressListModalOpen={isAddressListModalOpen}
                setIsAddressListModalOpen={setIsAddressListModalOpen}
                isAddAddressModalOpen={isAddAddressModalOpen}
                setIsAddAddressModalOpen={setIsAddAddressModalOpen}
                selectedAddressId={selectedAddressId}
                setSelectedAddressId={setSelectedAddressId}
                slotsAddressList={slotsAddressList}
                setSlotsAddressList={setSlotsAddressList}
                handleAddressSelectionForHomeService={handleAddressSelectionForHomeService}
              />
            </div>
            {(!isHomeServiceFlow || isReadonlyHomeServiceFlow) && (
              <div className="flex justify-between items-center mt-4">
                <div className="flex gap-5 items-center w-[80%]">
                  <NearbyLocationSearch
                    formHook={formHook}
                    disableSlotsFilter={disableSlotsFilter}
                    handleNearbyLocationSelect={handleNearbyLocationSelect}
                    handleNearbyLocationClear={handleNearbyLocationClear}
                  />
                  {showBDTemplateButton && (
                    <div className="w-full">
                      <button
                        type="button"
                        onClick={handleBDTemplateClick}
                        className="bg-[#000000] px-4 py-1.5 font-semibold rounded-lg cursor-pointer text-white text-sm"
                      >
                        Send VC link
                      </button>
                    </div>
                  )}
                </div>
                <div className="flex justify-end w-full">
                  <button
                    type="submit"
                    disabled={disableSlotsFilter}
                    className="bg-[#000000] px-4 py-1.5 font-semibold rounded-lg cursor-pointer text-white text-sm"
                  >
                    Search Slot
                  </button>
                </div>
              </div>
            )}
            {isPaidbooking && (
              <div className="bg-[#FFF2F2] p-3 w-full flex gap-2 rounded-md my-2">
                <div className="mt-1">
                  <BsExclamationCircle className="w-4 h-4 text-red-500 text-sm" />
                </div>
                <div>
                  <p className="text-sm text-[#D01111] font-medium flex items-center gap-2">Advance Payment Required</p>
                  <p className="text-sx text-[#D01111] flex">
                    An advance payment of{" "}
                    <span className="flex  text-xs items-center">
                      <BsCurrencyRupee className="w-3 h-3" />
                    </span>{" "}
                    <span className="font-semibold"> {isPaidPriceAmount} </span>&nbsp; will be required for the prepaid
                    slots
                  </p>
                </div>
              </div>
            )}
            {isSearchSlotButtonClick && hasShownNudges && (
              <NudgesContainer
                alert_category_list={alert_category_list}
                source="booking_journey"
                service_id={subServiceToServiceIdMap[formHook.watch("subService")] ?? ""}
                sub_service_id={formHook.watch("subService")}
              />
            )}
            {filtersError && (
              <>
                <span data-tooltip-id="filters_error" className="text-red-500 text-xs">
                  Please select valid filter combination{" "}
                  <InformationCircleIcon className="text-gray-600 w-4 h-4 inline cursor-pointer" />{" "}
                </span>
                <Tooltip
                  place="right"
                  id="filters_error"
                  render={() => {
                    return (
                      <div>
                        <p className="font-semibold">Valid Combinations</p>
                        <ol className="text-xs text-gray-100">
                          <li>City & Clinics</li>
                          <li>City , Clinic & Staff</li>
                          <li>Search By Location</li>
                        </ol>
                      </div>
                    );
                  }}
                />
              </>
            )}
          </form>
        </FadeIn>
      </div>
      {openVCLink && (
        <SendVCLink
          open={openVCLink}
          setOpen={setOpenVCLink}
          userId={customerId}
          petId={petId}
          petName={petDetails?.name}
          bookingId={rescheduleBookingId}
        />
      )}
    </div>
  );
};

export default BookingFiltersComponent;
